export const environmentConfig = {
    depService: process.env.VUE_APP_DEP_SERVICE || 'https://dep.penroseza.com',
};

// Goal Gambit internal productId (service.dep-integration src/app/config/sdp).
export const PRODUCT_ID = 44;
